import { Component, computed, Injector, input, OnInit, output, signal } from '@angular/core';
import { LookupOptionsService } from '../../services/lookup-options.service';
import { Option } from '../../../../../../shared/interfaces/lookup-options.interfaces';
import { templateDrivenFormsViewProviders } from '../../../../../../shared/directives/form.directive';
import { RadioButtonComponent } from '../../../../../../shared/components/forms/radio-button/radio-button.component';
import { FormsModule } from '@angular/forms';
import { toObservable } from '@angular/core/rxjs-interop';
import { doesFormPassValidations } from '../../pipes/form-validation.pipe';
import { SkeletonLoaderComponent } from '../../../../../../shared/components/skeleton-loader/skeleton-loader.component';

@Component({
  selector: 'app-service-options',
  imports: [RadioButtonComponent, FormsModule, SkeletonLoaderComponent],
  templateUrl: './service-options.component.html',
  styleUrl: './service-options.component.scss',
  viewProviders: [templateDrivenFormsViewProviders],
})
export class ServiceOptionsComponent implements OnInit {
  private serviceOptions = signal<Option[]>([]);

  loading = signal(false);
  formValue = input.required<Record<string, any>>();
  submittingValue = input.required<boolean>();
  formSubmitted = input.required<boolean>();
  activeStep = input.required<any>();

  formValid = output<boolean>();
  loadingData = output<boolean>();

  valid = signal(false);

  protected viewModel = computed(() => {
    return {
      serviceOptions: this.serviceOptions(),
      loading: this.loading(),
      formValue: this.formValue(),
      activeStep: this.activeStep(),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(
    private readonly injector: Injector,
    private readonly lookupOptionsService: LookupOptionsService
  ) {}

  ngOnInit(): void {
    this.loadInServiceOptions();
    this.validateForm();
  }

  loadInServiceOptions(): void {
    this.setLoadingState(true);

    this.lookupOptionsService.lookupOptionsForStep('service_option', '').subscribe({
      next: (data) => {
        this.setLoadingState(false);
        this.serviceOptions.set(data);
      },
      error: (error) => {
        this.setLoadingState(false);
        console.log({ error });
      },
    });
  }

  setLoadingState(loading: boolean): void {
    this.loading.set(loading);
    this.loadingData.emit(loading);
  }

  validateForm(): void {
    toObservable(this.formValue, { injector: this.injector })
      .pipe(doesFormPassValidations(this.vm.activeStep, { debounceTimer: 100 }))
      .subscribe({
        next: ({ valid }) => {
          this.valid.set(valid);
          // this.errors.set(errors);
          this.formValid.emit(valid);
        },
      });
  }
}
